const headers = [
  { text: 'Học sinh', value: 'student', width: '300px', align: 'left' },
  { text: 'Ngày sinh', value: 'dob', width: '150px', align: 'left' },
  { text: 'Lớp', value: 'currentClass', width: '100px', align: 'left' },
  { text: 'Ngày tham gia', value: 'createdAt', width: '150px', align: 'left' },
  { text: 'Thao tác', value: 'actions', width: '80px', align: 'right' }
]

export { headers }
